import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { DateTime } from 'luxon'

import { STRING } from 'resources'
import { WP_URLS } from 'resources/urls'

import generalSelectors from 'models/General/selectors'
import authSelectors from 'models/Authentication/selectors'

import {
  FooterContainer,
  ReklaimLogoYellow,
  TextLink,
  TextLinkSplit,
  CopyrightText,
  CopyrightContainer,
  LinkContainer,
  FooterSocialLinks,
} from './styles'

export const Footer = ({ isAppInitialized, isAuthenticated }) => {
  if (!isAppInitialized) {
    return null
  }
  return (
    <FooterContainer>
      <LinkContainer>
        <TextLink href={WP_URLS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
          {STRING.footer.privacyPolicy}
        </TextLink>
        {isAuthenticated && (
          <>
            <TextLinkSplit>{STRING.footer.linkSplitter}</TextLinkSplit>
            <TextLink href={WP_URLS.HOW_TO_EARN} target="_blank" rel="noopener noreferrer">
              {STRING.footer.earn}
            </TextLink>
          </>
        )}
        <TextLinkSplit>{STRING.footer.linkSplitter}</TextLinkSplit>
        <TextLink href={WP_URLS.NOTICE_OF_INCENTIVE} target="_blank" rel="noopener noreferrer">
          {STRING.footer.noticeOfIncentive}
        </TextLink>
      </LinkContainer>
      <FooterSocialLinks />
      <CopyrightContainer>
        <ReklaimLogoYellow alt={STRING.footer.reklaimLogoAlt} />
        <CopyrightText>{STRING.footer.copyrightText(DateTime.local().year)}</CopyrightText>
      </CopyrightContainer>
    </FooterContainer>
  )
}

Footer.propTypes = {
  isAppInitialized: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  isAuthenticated: authSelectors.getIsAuthenticated(state),
  isAppInitialized: generalSelectors.getIsAppInitialized(state),
})

export default connect(mapStateToProps)(Footer)
